(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/utils/constants.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/api/jupiter/vouchers/utils/constants.js');
'use strict';

setGlobal('svs.tur.payment.api.jupiter.vouchers.utils.constants.apierrors', {
  ERROR_BAD_RECEIEVER: 2,
  ERROR_INVALID_VOUCHER_ID: 4,
  ERROR_INVALID_PARAM: 5,
  ERROR_USER_SUSPENDED: 6,
  ERROR_INVALID_COUNT: 7,
  ERROR_ACCOUNT_LOW: 8,
  ERROR_INVALID_DELIVERY_DATE: 9,
  ERROR_CRITICAL: 10,
  ERROR_DEPOSIT_BUDGET_NOT_SET: 11
});

 })(window);